import styled from "@emotion/styled";
import { Skeleton } from "antd5";
import { Flex } from "styles/utility-components";

import UserInitials, { UnassignedIcon, UserInitialsType } from "components/comments/UserInitials";
import UIcon from "lib/icons/untitled_ui/UIcon";
import { AnswerMarkdown } from "./AnswerMarkdown";

import css from "./AiQuestionAndAnswer.module.scss";

type AiQuestionAndAnswerProps = {
  question: string;
  answer: string | undefined; // Undefined for when an answer is not available yet
  trackingLinkContext?: (guid: string) => void;
  saveQuestionComponent?: JSX.Element;
  type?: UserInitialsType;
};
/**
 * Generic component for displaying a question and answer pair from our AI
 * @param param0
 * @returns
 */
export function AiQuestionAndAnswer({
  question,
  answer,
  saveQuestionComponent,
  trackingLinkContext,
  type = "default",
}: AiQuestionAndAnswerProps) {
  const currentUser = window.currentUser;
  return (
    <div className={css.questionAndAnswer}>
      <div className={css.userQuestionRow}>
        {window.guestUser ? (
          <UnassignedIcon showTooltip={false} type={type} />
        ) : (
          <UserInitials
            firstName={currentUser?.first_name}
            lastName={currentUser?.last_name}
            className={css.avatar}
            type={type}
          />
        )}
        <div className={css.userQuestion}>
          <p className={css.userHeader}>{window.guestUser ? "You" : currentUser?.first_name}</p>
          <p>{question}</p>
          {/* Render saveQuestionComponent if it's provided */}
          {saveQuestionComponent}
        </div>
      </div>

      {answer ? (
        <div className={css.ariAnswerRow}>
          <AIAvatar type={type}>
            <UIcon icon="stars2" color="white" />
          </AIAvatar>
          <div className={css.ariAnswer}>
            <p className={css.ariHeader}>Stotles AI</p>
            <AnswerMarkdown answer={answer} trackingLinkContext={trackingLinkContext} />
          </div>
        </div>
      ) : (
        <Skeleton active avatar />
      )}
    </div>
  );
}

function getHeightAndWidthByType(type: UserInitialsType) {
  switch (type) {
    case "default":
      return { height: 32, width: 32 };
    case "small":
      return { height: 26, width: 26 };
    case "extra-small":
      return { height: 20, width: 20 };
  }
}

const AIAvatar = styled(Flex)<{ type: UserInitialsType }>(({ theme, type }) => {
  const { height, width } = getHeightAndWidthByType(type);
  return {
    height,
    width,
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.colors.sysBrandBlueDefault,
    flexShrink: 0,
  };
});
